import React from 'react';
import { FlipIndicator } from '../../job-indicators';

export default function FlipBadge({ job }) {
  // We'll reuse the FlipIndicator from job-indicators.js
  return <FlipIndicator job={job} />;
} 